<app-modal
  [title]="'Assign price category' | trans:'cart/price-category-picker-modal/header/title'"
  maxWidth="728px"
  width="100%"
>
  <ng-container modal-precontent>
    <div class="d-flex align-items-center gap-8 p1">
      <p>
        {{ show?.title }}
      </p>
      <p>
        {{ show?.movieInfo }}
      </p>
    </div>
  </ng-container>

  <ng-template>
    <div>
      <p class="t4 fw-medium text-uppercase">
        {{ 'Ticket types' | trans:'cart/price-category-picker-modal/price-categories.Title' }}
      </p>

      <div class="m-t-8 d-flex gap-24 flex-wrap">
        @for (priceCat of ((!reservationsStore.rebookReservation() && data.ticket.isFromReservation ? (priceCategories | arrayFilter:excludeReservationPriceCategory) : priceCategories) | arraySortByKey:'priceCategoryPickerOptionPositionInWebCash'); track priceCat.id) {
          <div class="d-flex flex-direction-column gap-4">
            <app-chip
              [value]="priceCat.id"
              [selected]="priceCat.id === selectedPriceCategoryId"
              [disabled]="priceCat.id !== selectedPriceCategoryId"
              [label]="priceCat.token || priceCat.name"
              [suffixIcon]="(priceCat.cardTypeId ?? priceCat.flagAcardo ?? priceCat.flagCineville) ? 'ri-bank-card-line' : undefined"
              [suffixIconClass]="''"
              (onClick)="onPriceCategoryChipClick(priceCat)"
            />
          </div>
        }
      </div>

      @if (!isSelectedCategoryCineville) {
        <div class="m-t-24 d-flex align-items-center gap-16">
          <app-switch
            text="{{ 'Apply to all' | trans:'cart/price-category-picker-modal/applyToAll.Text' }}"
            [(ngModel)]="isApplyToAllEnabled"
            [disabled]="isAcardoSelectedCategory || selectedCategoryRequiresSingleTicket"
            (ngModelChange)="onApplyToAllEnabledChange($event)"
          />
          <app-stepper
            [maxValue]="stepperMaxForApplyAll"
            [(ngModel)]="selectedTicketsCount"
            [disabled]="isAcardoSelectedCategory || !isApplyToAllEnabled || selectedCategoryRequiresSingleTicket"
          />
        </div>
      }
    </div>
  </ng-template>

  <ng-container modal-buttons>
    <div class="d-flex gap-16 m-t-16 justify-content-flex-end">
      <button
        class="button button--md button--primary-ghost text-uppercase"
        (click)="close()"
        type="button"
      >
        {{ 'Cancel'| trans:'cart/price-category-picker-modal/cancel.Button' }}
      </button>
      <button
        #btn
        class="button button--md button--primary text-uppercase"
        (click)="confirmPriceCategoriesSelection(btn)"
        type="button"
        [disabled]="isApplyToAllEnabled && !selectedTicketsCount"
      >
        {{ 'Confirm'| trans:'cart/price-category-picker-modal/confirm.Button' }}
      </button>
    </div>
  </ng-container>
</app-modal>

<app-card-code-input-modal
  #cardCodeInputModalComponent
  [skipCardProductsAfterAttach]="true"
  (onClose)="onAttachCardModalClosed()"
  (codeSubmitted)="onAcardoCodeSubmitted($event)"
  (addPaymentMethodSuccess)="onCardAttachedForPriceCategory($event)"
/>

<app-cineville-partner-code-modal
  (categoryChangeCompleted)="close()"
  (categoryChangeCancelled)="onCinevilleCategoryChangeCancelled()"
/>
